import { render, staticRenderFns } from "./HistorialRetiro.vue?vue&type=template&id=4c0108e5"
import script from "./HistorialRetiro.vue?vue&type=script&lang=js"
export * from "./HistorialRetiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports